export default __webpack_public_path__ + "static/media/surfWax.8ad6859a.jpg";